import { cn } from "../../../lib/utils";
import React from 'react';
import * as styles from "./divider";
import { jsx as _jsx } from "react/jsx-runtime";
var Divider = function Divider(_ref) {
  var className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'horizontal' : _ref$type,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'center' : _ref$orientation,
    _ref$line = _ref.line,
    line = _ref$line === void 0 ? 'solid' : _ref$line,
    theme = _ref.theme;
  return /*#__PURE__*/_jsx("div", {
    style: style,
    className: cn(className, styles.divider, styles[type], styles[line], styles[orientation], theme === 'dark' ? styles.darkTheme : styles.lightTheme),
    children: children ? /*#__PURE__*/_jsx("span", {
      className: styles.dividerContent,
      children: children
    }) : null
  });
};
export default Divider;